import * as React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { useTheme } from '../../../../../theme';
import { getPassengerTypeLabel } from '../../../../../utils';
import Money from '../../../../../Money';
import { useShowTaxesInfo } from '../../../../../hooks';
const TaxesDetails = ({ className, taxesFormat = 'short', passengerFares, additionalPrices, totalPrice }) => {
    const { t } = useTranslation('DesktopFlightInfo');
    const { TaxesDetails: theme } = useTheme('Entities').Fare;
    const showTaxesInfo = useShowTaxesInfo();
    if (!showTaxesInfo) {
        return null;
    }
    return (React.createElement("div", { className: cn(theme.price__details, className) },
        passengerFares.map((passengerFare, index) => (React.createElement(React.Fragment, { key: index },
            React.createElement("div", { className: theme.price__group },
                React.createElement("div", { className: theme.price__label },
                    passengerFare.count,
                    ' ',
                    getPassengerTypeLabel(passengerFare.passengerType, undefined, passengerFare.count)),
                React.createElement("div", { className: theme.price__item },
                    React.createElement("span", null, t('Tariff')),
                    " ",
                    React.createElement(Money, { money: passengerFare.baseFare })),
                taxesFormat === 'short' && (React.createElement("div", { className: theme.price__item },
                    React.createElement("span", null, t('Taxes')),
                    " ",
                    React.createElement(Money, { money: passengerFare.totalTaxes }))),
                taxesFormat === 'detailed' &&
                    'taxes' in passengerFare &&
                    passengerFare.taxes.map(tax => (React.createElement("div", { key: tax.code, className: theme.price__item },
                        React.createElement("span", null, t(`TaxCode.${tax.code}`, `${t('Fee')} ${tax.code}`)),
                        React.createElement(Money, { money: {
                                amount: tax.price.amount * passengerFare.count,
                                currency: tax.price.currency
                            } })))))))),
        (!!(additionalPrices === null || additionalPrices === void 0 ? void 0 : additionalPrices.length) || totalPrice) && React.createElement("div", { className: theme.price__separator }),
        totalPrice && (React.createElement("div", { className: cn(theme.price__item, theme.price__item_highlighted) },
            React.createElement("span", null, t('Total')),
            " ",
            React.createElement(Money, { money: totalPrice }))), additionalPrices === null || additionalPrices === void 0 ? void 0 :
        additionalPrices.map((item, index) => (React.createElement("div", { key: index, className: cn(theme.price__item, { [theme.price__item_highlighted]: item.highlighted }) },
            React.createElement("span", null, item.label),
            " ",
            React.createElement(Money, { money: item.price }))))));
};
export default TaxesDetails;
